Object.defineProperty(exports, "__esModule", {
  value: true
});

var React = require("react");

var blocks_1 = require("./blocks");

var WPGBlocks = function WPGBlocks(_ref) {
  var blocks = _ref.blocks,
      mapToBlock = _ref.mapToBlock;
  return React.createElement("div", {
    className: "wpg-blocks"
  }, blocks.filter(function (block) {
    return !!block.blockName;
  }).map(function (block, index) {
    return React.createElement(exports.WPGBlock, {
      key: index,
      block: block,
      mapToBlock: mapToBlock
    });
  }));
};

exports.WPGBlock = function (_ref2) {
  var block = _ref2.block,
      mapToBlock = _ref2.mapToBlock;
  var blockName = block.blockName,
      attrs = block.attrs,
      innerBlocks = block.innerBlocks,
      innerHTML = block.innerHTML;
  if (!blockName) return null;
  if (mapToBlock) exports.WPGBlock.MapToBlock = mapToBlock;
  var TheBlock = exports.WPGBlock.MapToBlock ? exports.WPGBlock.MapToBlock(blockName) : null;
  if (!TheBlock) TheBlock = blocks_1.GetTheBlock(blockName);
  if (!TheBlock) return null;
  return React.createElement(TheBlock, {
    blockName: blockName,
    attrs: attrs,
    innerBlocks: innerBlocks,
    innerHTML: innerHTML
  });
};

exports.default = WPGBlocks;